export enum TestimonialType {
  Kampfkunst,
  Vektoren,
}

type Testimonial = {
  name: string;
  text: string;
  types: TestimonialType[];
};

export const TESTIMONIALS: Testimonial[] = [
  {
    // 1
    name: 'Sascha, Polizist, Berlin',
    text: 'Ich war begeistert! Denn es war anders als all die anderen Sachen, die ich bisher kennen gelernt hatte. Plötzlich waren Entspannung, Flexibilität, Achtsamkeit und Gelassenheit gefragt.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 2
    name: 'Bruno, Unternehmer, São Paulo',
    text: 'Das Training ist eine großartige Übung für Demut und echtes Wachstum, immer und immer wieder.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 3
    name: 'Juhani, Unternehmer, Helsinki',
    text: 'Meister Falko ist sehr hilfsbereit, aktiv und freundlich. Es ist ein Vergnügen von ihm zu lernen.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 4
    name: 'Kiarash, Unternehmer, Berlin',
    text: 'Obwohl ich leidenschaftlicher Boxer bin, sehe ich, dass es viel mehr Wertigkeit hat, das Training in Systema zu vertiefen.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 5
    name: 'Simone, Schauspielerin, Berlin',
    text: 'Ich kann sagen, dass Systema dazu beigetragen hat, dass ich entspannter bin, es mir besser geht und dass ich durch das regelmäßig Training stabiler und klarer geworden bin.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 6
    name: 'Bruno, Ton-Techniker, Paris',
    text: 'Systema war ein Wendepunkt in meinem Kampfsport-Leben. Maximale Information, sofortiger Erfolg, sehr präzise und intuitiv.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 7
    name: 'Eckhard, Designer, Bad Sachsa',
    text: 'Systema ist wirklich Hammer, ein absolut neues Level! Ich kann mich unglaublich weiterentwickeln.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 8
    name: 'Eva, Linguistin, Berlin',
    text: 'Als eine kleine Frau weiß ich, dass ich mich nicht auf meine physische Stärke verlassen kann - und es stellte sich heraus, dass Lernen basierend auf Entspannung eine großartige Lösung für mich war.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 9
    name: 'Paul, Architekt, USA',
    text: 'Ich bin sehr glücklich diesen Stil trainieren zu können. Das Training ist fantastisch!',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 10
    name: 'Dirk, Geschäftsführer, Berlin',
    text: 'Ich wusste: Entweder ich lande im Gefägnis oder ich gehe einen neuen Weg. Ich möchte bei meiner Frau sein und nicht im Knast. Ich möchte anders mit Konflikt und Aggression umgehen. Deshalb bin ich hier.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 11
    name: 'Lisian, Verkäufer, Berlin',
    text: 'Ich habe mehr als 10 Jahre andere Kampfsportarten trainiert. Systema ist das Beste! Schade, dass ich nicht früher angefangen habe!',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 12
    name: 'Jens, Gefangener, Brandenburg a.d.H.',
    text: 'Ich möchte die Techniken für Selbstverteidigung gar nicht erlernen. Mein Körper ist so steif und tut weh. Mir hilft das Training dabei, zu entspannen und endlich wieder durchzuschlafen.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 13
    name: 'Michal, Physiotherapeut, Berlin',
    text: 'Im Fokus steht für mich die Kampfkunst mit der Meisterschaft im Kontakt, Sensibilität, Balance, Leichtigkeit und Entspannung. Es faszinieren mich die Feinheiten und Präzision im Umgang mit der Schwerkraft und das Streben nach Harmonie in einer natürlichen Bewegung.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 14
    name: 'Lena, Tänzerin, Berlin',
    text: 'Ich bin ohne Helm bei 25km/h mit dem Elektro-Fahrrad ausgerutscht und über den Lenker gestürzt. Ich hatte nur kleine Abschürfungen und konnte sofort weiter fahren. Systema hat mich gerettet.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 15
    name: 'Ben, Marketing, Berlin',
    text: 'Ich habe mit dem Fahrrad einen Bus gerammt. Ich habe es geschafft am Bus entlang abzurollen. So wurde ich nicht überfahren, sondern habe nur eine Narbe am rechten Arm. Ich hätte tot sein können.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 16
    name: 'Dimitri, Reitlehrer, Berlin',
    text: 'Im Reitsport sind Stürze immer ein wichtiges Thema. Erst durch  das Wissen von Systema, konnte ich eine fundierte und effektive Fallschule für meine Schüler entwickeln. Diese ermöglicht es, Stürze sicherer und kontrollierter abzufangen, was sowohl das Verletzungsrisiko minimiert als auch das Vertrauen in die eigenen Fähigkeiten stärkt.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 17
    name: 'Leiv, Busfahrer, Berlin',
    text: 'Er kam sehr aggressiv auf mich zu und schubste mich stark. Ich kam nicht einmal richtig aus dem Gleichgewicht, sondern konnte meine Balance wie im Training halten. Danach gelang es mir, die Situation zu deeskalieren.',
    types: [TestimonialType.Kampfkunst],
  },
  {
    // 18
    name: 'Elena, Angestellte, Berlin',
    text: 'Vektor-Psychologie hat mir geholfen, die Beweggründe von Leuten in meiner Umgebung zu verstehen und harmonische Beziehungen mit ihnen aufzubauen.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 19
    name: 'Mirko, Manager, Berlin',
    text: 'Ich habe gelernt die Stärken und Schwächen meiner Kollegen besser zu verstehen. So konnte ich die Aufgaben besser verteilen. Jetzt sind wir erfolgreicher und jedem macht der Job mehr Spaß.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 20
    name: 'Sascha, Kriminalpolizist, Berlin',
    text: 'Die Vektor-Psychologie bietet Erklärungsansätze für menschliches Handeln und Denken. Sie vermittelt, warum Menschen manchmal nicht aus ihrer Haut heraus kommen, aber auch wie man ihnen im Umgang Brücken bauen kann. Sich selbst darin wieder zu finden ist übrigens auch sehr interessant und erkenntnisreich.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 21
    name: 'Lisian, Verkäufer, Berlin',
    text: 'Die Vektortheorie hilft mir, die Psychologie des Menschen besser zu verstehen. In meinen Augen ist die Vektortheorie das mächtigste psychologische Werkzeug, um einen Menschen, auch ohne ihn zu kennen, einschätzen zu können. Es macht das Miteinander kalkulierbarer.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 22
    name: 'Waldemar, Justiz, Trier',
    text: 'Die Vektor Vorlesungen sehe ich als großen Mehrwert und Möglichkeit für tolle Erkenntnisse und Selbsterkenntnisse in meinem Lebensalltag. In dem ich mich selbst besser kennengelernt habe, finde ich einen leichteren Zugang zu meinen Mitmenschen. Insgesamt hat es mir zu einer harmonischen und positiveren Lebensqualität verholfen.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 23
    name: 'Dimitri, Justiz, Trier',
    text: 'Die Vektor-Vorlesung hat mir eine neue Perspektive eröffnet und mir geholfen, die Welt durch die Augen anderer zu sehen. Seitdem hat sich meine Einstellung und mein Umgang mit meinen Mitmenschen spürbar verbessert.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 24
    name: 'Daniel, Investor, Berlin',
    text: 'Für meine Frau und mich ist es ein riesiger Gewinn unsere Bedürfnisse und Eigenarten besser zu verstehen, sie zu akzeptieren und damit umzugehen. Anstatt unsere Unterschiede zu bemängeln, nutzen wir sie besser, um uns zu ergänzen.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 25
    name: 'Andreas, Compliance-Manager, Frankfurt a.M.',
    text: 'Durch die Vorlesung kann ich meine eigenen Emotionen und Verhaltenmuster, sowie die meiner Mitmenschen besser verstehen. Mehr Gelassenheit und Harmonie im Alltag sind die Folge. Danke dafür.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 26
    name: 'Sabrina, Steuerberater, Berlin',
    text: 'Die Vektorenlehre ist eine absolute Bereicherung! Mein Alltag gestaltet sich viel leichter, seitdem ich die Vektoren der Menschen um mich herum verstehe. Die Beziehungen zu meinen Liebsten und auch zu meinen Kollegen haben sich verändert, das macht vieles einfacher und das Leben schöner.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 27
    name: 'Robert, Media-Consultant, Berlin',
    text: 'Die Konzepte der Vektor-Psychologie geben eine anschauliche Struktur, um die eigene Persönlichkeit zu reflektieren und helfen gegenüber den Mitmenschen verständnis- sowie liebevoller zu sein. Außerdem sind die Vorlesungen und Diskussionen sehr unterhaltsam.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 28
    name: 'Lutz, Psychologe, Berlin',
    text: 'Das Konzept der Vektorpsychologie bietet seinen Anwendern eine gute Möglichkeit, sich selbst und andere im Erleben und Verhalten einzuschätzen. Es hilft dabei, zwischenmenschliche Beziehungen zu verstehen und zu gestalten. Die Vorträge sind gut strukturiert, immer mit einer ordentlichen Prise Humor versehen und sie sind spannend - so wie das Konzept selbst.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 29
    name: 'Martin, Unternehmer, Berlin',
    text: 'Die Vektorenlehre ist sehr wirksam, um seine Mitmenschen besser zu verstehen. Es hilft mir in allen Lebensbereichen, vor allem im Führungsbereich. Falko trägt sehr kurzweilig und amüsant vor - absolut empfehlenswert!',
    types: [TestimonialType.Vektoren],
  },
  {
    // 30
    name: 'Dima, Tai-Chi Lehrer, Berlin',
    text: 'Die Vektorpsychologie hat mir sowohl im privaten als auch im beruflichen Bereich geholfen, mein Gegenüber besser zu verstehen und auf dessen Verhaltensmuster einzugehen. Dies ermöglichte mir unter anderem, meinen Unterricht gezielter auf die Bedürfnisse meiner Schüler auszurichten, wodurch sie deutlich größere Lernerfolge erzielen konnten.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 31
    name: 'Michal, Physiotherapeut, Berlin',
    text: 'Mit der Vektorenpsychologie gewinnt man wertvolle Erkenntnisse über sich selbst und andere. Die archetypischen Handlungsmuster lassen sich überraschend schnell im Alltag, Familie, und Beruf wiederfinden.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 32
    name: 'Jakob, Osteopath, Berlin',
    text: 'Die Vektortheorie ist ein spannendes Konzept um Stärken, Schwächen und die Beweggründe des Handelns zu ergründen. Meine eigenen genauso wie die meiner Mitmenschen.',
    types: [TestimonialType.Vektoren],
  },
  {
    // 33
    name: 'Juan, Movement Teacher, Melbourne',
    text: 'Systema ist eine einzigartige Kunst. Das beste System, um den Körper zu verstehen. Eine sehr ehrliche und transformierende Arbeit.',
    types: [TestimonialType.Kampfkunst],
  },
];
